import { render, staticRenderFns } from "./Publicar2.vue?vue&type=template&id=27ecb17e&scoped=true"
import script from "./Publicar2.vue?vue&type=script&lang=js"
export * from "./Publicar2.vue?vue&type=script&lang=js"
import style0 from "./Publicar2.vue?vue&type=style&index=0&id=27ecb17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecb17e",
  null
  
)

export default component.exports